import { Inject, Injectable } from '@angular/core';
import { SystemPreferenceApiService, UpdateSystemPreferenceDto } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { lastValueFrom } from 'rxjs';
import { ClientNotificationHandlerService } from '../..';
import { ClientEnvironment, ENVIRONMENT } from '../environment';
import { CommonUtilityLib, StorageUtilityLib } from '../util';

export interface SystemPreferences {
  brandingKey: string;
  dashboardCollection?: string[];
  dashboardKeywords?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class SystemPreferencesService {
  systemPreference!: SystemPreferences;
  brandingKey = '';
  CustomClients = CustomClients;
  constructor(
    private storageUtilityLib: StorageUtilityLib,
    private commonUtilityLib: CommonUtilityLib,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
    @Inject(ENVIRONMENT) env: ClientEnvironment,
    private systemPreferenceService: SystemPreferenceApiService,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  async getUserPreferences() {
    if (!this.systemPreference || !this.systemPreference.brandingKey) {
      const responseData: SystemPreferences = await lastValueFrom(this.systemPreferenceService.systemPreferenceControllerFindOne(this.brandingKey));
      this.systemPreference = {
        brandingKey: responseData.brandingKey,
        dashboardCollection: responseData.dashboardCollection,
        dashboardKeywords: responseData.dashboardKeywords,
      };
    }
    return this.systemPreference;
  }

  /**
   * set user preferences from localStorage
   * @param columns
   * @param refKey (project | task | asset)
   * @param tabKey (tab unique key)
   */
  async updateUserPreferences(data: SystemPreferences, updatedKey?: string) {
    const brandingKey = data.brandingKey;
    const updateObject: UpdateSystemPreferenceDto = { ...data };
    this.systemPreference = { ...this.systemPreference, ...data };
    this.systemPreferenceService.systemPreferenceControllerUpdate(brandingKey, updateObject).subscribe({
      next: () => {
        if (updatedKey == 'collection') {
          this.clientNotificationHandlerService.successNotification($localize`Collections on dashboard updated successfully`);
        } else {
          this.clientNotificationHandlerService.successNotification($localize`Tags on dashboard updated successfully`);
        }
      },
    });
    return this.systemPreference;
  }
}
